/**
 * Plays a short notification tone via Web Audio API.
 * Safe to call repeatedly; failures are logged and ignored.
 */
export function playNotificationSound(): void {
  try {
    const AudioCtx = window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext;
    if (!AudioCtx) return;

    const ctx = new AudioCtx();
    const oscillator = ctx.createOscillator();
    const gain = ctx.createGain();

    oscillator.type = 'sine';
    oscillator.frequency.value = 880;
    gain.gain.value = 0.25;

    oscillator.connect(gain);
    gain.connect(ctx.destination);

    oscillator.start();
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.45);
    oscillator.stop(ctx.currentTime + 0.5);

    oscillator.onended = () => {
      ctx.close().catch(() => undefined);
    };
  } catch (error) {
    console.warn('[WindowReset] Could not play notification sound:', error);
  }
}
